import { render, staticRenderFns } from "./order_afte_sale.vue?vue&type=template&id=19d7e4a1&"
import script from "./order_afte_sale.vue?vue&type=script&lang=js&"
export * from "./order_afte_sale.vue?vue&type=script&lang=js&"
import style0 from "./order_afte_sale.vue?vue&type=style&index=0&id=19d7e4a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports